export default __webpack_public_path__ + "static/media/ceramol-acn3-spot-block-640.d0938684.png";